export default [
  {
    name: 'question',
    path: '/question',
    component: () => import('@/view/question/index.vue')
  },
  {
    name: 'question/hot',
    path: '/question/hot',
    component: () => import('@/view/question/hot.vue')
  },
  {
    name: 'question/production',
    path: '/question/production',
    component: () => import('@/view/question/production.vue')
  },
  {
    name: 'question/invoice',
    path: '/question/invoice',
    component: () => import('@/view/question/invoice.vue')
  },
  {
    name: 'question/check',
    path: '/question/check',
    component: () => import('@/view/question/check.vue')
  },
  {
    name: 'question/withdraw',
    path: '/question/withdraw',
    component: () => import('@/view/question/withdraw.vue')
  },
  {
    name: 'question/repay',
    path: '/question/repay',
    component: () => import('@/view/question/repay.vue')
  },
  {
    name: 'question/security',
    path: '/question/security',
    component: () => import('@/view/question/security.vue')
  },
  {
    name: 'question/cmbc',
    path: '/question/cmbc',
    component: () => import('@/view/question/cmbc.vue')
  }
]